import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { Translate } from 'react-localize-redux';

import AppState from '@webapp/store/state';
import { UpdateField } from '@webapp/store/release/action-creators';

import styled from 'styled-components';

import Checkbox from '@components/form/checkbox';
import Typography from '@components/basics/typography';
import { hasPlanFeature } from '@webapp/sdk/plans';
import { PlanNames } from '@services/product/types/plan-names';

interface StoreMaximizerCtrlProps {
  className?: string;
  isStoreMaximizer?: boolean;
  updateIsStoreMaximizer: (value: boolean) => UpdateField<'isStoreMaximizer'>;
}

const mapStateToProps = (state: AppState) => ({
  isStoreMaximizer: state.release.release?.isStoreMaximizer,
  isPlanFeature: hasPlanFeature(
    state.subscription.current?.plan.toLowerCase() as PlanNames,
    'RELEASE.STORE_MAXIMIZER'
  ),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateIsStoreMaximizer: (value: boolean) =>
    dispatch(new UpdateField<'isStoreMaximizer'>('isStoreMaximizer', value)),
});

export const StoreMaximizerCtrl: React.FC<StoreMaximizerCtrlProps> = ({
  isStoreMaximizer,
  updateIsStoreMaximizer,
  ...props
}) => {
  React.useEffect(() => {
    if (isStoreMaximizer === undefined) {
      updateIsStoreMaximizer(true);
    }
  }, [isStoreMaximizer, updateIsStoreMaximizer]);

  return (
    <Checkbox
      className={props.className}
      active={!!isStoreMaximizer}
      title={<Translate id="RELEASE.STORE_PLUS.TITLE" />}
      titleDecoration={
        <PlusWrapper>
          <PlusTypography weight="700" type="small">
            <Translate id="RELEASE.STORE_PLUS.TITLE_PLUS" />
          </PlusTypography>
        </PlusWrapper>
      }
      text={<Translate id="RELEASE.STORE_PLUS.COPY" />}
      onClick={() => updateIsStoreMaximizer(!isStoreMaximizer)}
    />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreMaximizerCtrl);

const PlusWrapper = styled.div`
  padding: 2px 8px;
  margin-left: 8px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.blueColor};

  span {
    color: ${({ theme }) => theme.colors.white};
  }
`;

const PlusTypography = styled(Typography)`
  color: ${({ theme }) => theme.colors.differentBackground};
`;
